class Wishlist {
  constructor () {
    this.eventBus = {
      wishlist_ready: 'WISHLIST_READY',
      wishlist_add_product: 'WISHLIST_ADD_PRODUCT',
      wishlist_added_product: 'WISHLIST_ADDED_PRODUCT',
      wishlist_remove_product: 'WISHLIST_REMOVE_PRODUCT',
      wishlist_removed_product: 'WISHLIST_REMOVED_PRODUCT',
    }

    this.wishlist = null
    this.readyPromise = this.checkReady()
    this.wishlistPromise = this.setDefaultWishlist()

    this.setupListeners()
  }

  setupListeners () {
    window.addEventListener(this.eventBus.wishlist_ready, () => {
      this.initialise()
    })

    window.addEventListener(this.eventBus.wishlist_add_product, (e) => {
      this.handleHeaderButton(true)
      this.addProduct(
        e.detail.variantId,
        e.detail.productId,
        e.detail.productUrl,
        e.detail.productTitle,
        e.detail.productPrice,
      )
    })

    window.addEventListener(this.eventBus.wishlist_added_product, (e) => {
      this.handleHeaderButton(false)
      this.handleCount()
    })

    window.addEventListener(this.eventBus.wishlist_remove_product, (e) => {
      this.handleHeaderButton(true)
      this.removeProduct(
        e.detail.variantId,
        e.detail.productId,
        e.detail.productUrl,
        e.detail.productTitle,
        e.detail.productPrice,
      )
    })

    window.addEventListener(this.eventBus.wishlist_removed_product, (e) => {
      this.handleHeaderButton(false)
      this.handleCount()
    })
  }

  async checkReady () {
    while (!window._swat) {
      await new Promise(resolve => setTimeout(resolve, 200))
    }

    const event = new CustomEvent(this.eventBus.wishlist_ready)
    window.dispatchEvent(event)
  }

  async initialise () {
    await this.readyPromise
    await this.wishlistPromise

    this.handleCount()

    this.initialiseElements()
  }

  async setDefaultWishlist () {
    try {
      const wishlists = await this.fetchWishlists()

      if (wishlists && wishlists.length > 0) {
        this.wishlist = wishlists[0]
      } else {
        const newWishlist = await this.createWishlist()

        if (newWishlist) {
          this.wishlist = newWishlist
        }
      }
    } catch (error) {
      console.error('setDefaultWishlist() - Error', error)
    }
  }

  async createWishlist () {
    await this.readyPromise

    return new Promise((resolve) => {
      const listConfig = {
        lname: 'Wishlist',
      }
      const onSuccess = function (list) {
        resolve(list)
      }
      const onError = function (error) {
        console.error('createWishlist() - Error', error)
        resolve(null)
      }

      window._swat.createList(listConfig, onSuccess, onError)
    })
  }

  initialiseElements () {
    const wishlistElements = document.querySelectorAll('[data-wishlist-el]')

    wishlistElements.forEach(element => {
      element.setAttribute('aria-hidden', 'false')
    })
  }

  async addProduct (variantId, productId, productUrl) {
    await this.wishlistPromise

    const product = {
      epi: variantId,
      empi: productId,
      du: productUrl,
    }
    const event = new CustomEvent(this.eventBus.wishlist_added_product, {
      detail: product,
    })

    window._swat.addToList(
      this.wishlist.lid,
      product,
      () => window.dispatchEvent(event),
      (error) => console.error('addProduct() - Error', error),
    )
  }

  async removeProduct (variantId, productId, productUrl) {
    await this.wishlistPromise

    const product = {
      epi: variantId,
      empi: productId,
      du: productUrl,
    }
    const event = new CustomEvent(this.eventBus.wishlist_removed_product, {
      detail: product,
    })

    window._swat.deleteFromList(
      this.wishlist.lid,
      product,
      () => window.dispatchEvent(event),
      (error) => console.error('removeProduct() - Error', error),
    )
  }

  async fetchWishlists () {
    await this.readyPromise

    return new Promise((resolve) => {
      window._swat.fetchLists({
        callbackFn: (wishlists) => resolve(wishlists),
        errorFn: (error) => console.error('fetchWishlists() - Error', error),
      })
    })
  }

  async fetchWishlist (lid = null, retryCount = 0) {
    await this.readyPromise
    await this.wishlistPromise

    return new Promise((resolve) => {
      const listConfig = {
        lid: lid || this.wishlist.lid,
      }
      const onSuccess = (wishlist) => {
        if ((wishlist?.list === null && wishlist?.items === null) || !wishlist) {
          if (retryCount < 3) {
            setTimeout(async () => {
              const retryResult = await this.fetchWishlist(lid, retryCount + 1)
              resolve(retryResult)
            }, 200)
            return
          }
        }

        resolve(wishlist)
      }
      const onError = function (error) {
        console.error('fetchWishlist() - Error', error)
        resolve(null)
      }

      window._swat.fetchListDetails(listConfig, onSuccess, onError)
    })
  }

  async fetchSocialCount (productId, productUrl) {
    await this.readyPromise

    return new Promise((resolve) => {
      const onSuccess = (response) => resolve(response?.data?.count || 0)
      const onError = function (error) {
        console.error('fetchSocialCount() - Error', error)
        resolve(0)
      }

      window._swat.socialCount(onSuccess, onError, productUrl, Number(productId), undefined, 'wishlist')
    })
  }

  async handleCount () {
    await this.readyPromise
    await this.wishlistPromise

    const countEls = document.querySelectorAll('[data-wishlist-el="count"]')

    if (countEls.length === 0) return

    const wishlist = await this.fetchWishlist()

    let count = wishlist.items.length

    if (count > 99) {
      count = '99+'
    }

    countEls.forEach(countEl => {
      countEl.textContent = count > 0 ? count : ''
      countEl.setAttribute('data-wishlist-empty', count === 0)
    })
  }

  handleHeaderButton (isBusy) {
    const headerButton = document.querySelector('[data-wishlist-el="headerButton"]')

    if (headerButton) {
      headerButton.setAttribute('aria-busy', isBusy.toString())
    }
  }
}

window.theme.wishlist = new Wishlist()
